import axios from './axios-auth';

const getMainOrderStatus = () =>
    new Promise((resolve, reject) => {
        axios({
            url: '/dv-adm/getallboporderstatus',
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log('error from get main order status api');
            });
    });

const getSecondaryStatus = () =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getallbopsecondarystatus',
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log('error from get secondary status api');
            });
    });

const getAllSuppliers = () =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getallbopsuppliers',
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log('error from get all suppliers api');
            });
    });

const getAllCompanies = () =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getallbopcompanies',
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log('error from get all companies api');
            });
    });

const getAllSavedSearch = () =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getbopsavedsearch',
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log('error from get all companies api');
            });
    });

const getAllViewBatchList = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getbatchorders',
            params: payload.params,
            data: payload.bodyParams,
            method: 'POST',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from get all view batch list');
            });
    });

const getBatchProcessSavedSearch = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getrecentbatches',
            params: payload,
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from getBatchProcessSavedSearch api');
            });
    });

const getSavedSearchById = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/getsavedsearchbyid',
            params: payload,
            method: 'GET',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from getSavedSearchById api');
            });
    });

const addBatchProcessSaveSearch = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/bopsavesearch',
            data: payload,
            method: 'POST',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from addBatchProcessSaveSearch api');
            });
    });

const editBatchProcess = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/updatebatch',
            data: payload,
            method: 'POST',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from addBatchProcessSaveSearch api');
            });
    });

const removeBatchById = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/deletebatch',
            params: payload,
            method: 'DELETE',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from removeBatchById api');
            });
    });

const updateBatchProcessFile = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: 'dv-adm/bopexporttoexcel',
            data: payload,
            method: 'POST',
            responseType: 'blob',
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log('error from updateBatchProcessFile api');
            });
    });

export { getMainOrderStatus, getSecondaryStatus, getAllSuppliers, getAllCompanies, getAllSavedSearch, getAllViewBatchList, getBatchProcessSavedSearch, getSavedSearchById, addBatchProcessSaveSearch, editBatchProcess, removeBatchById, updateBatchProcessFile };
